import { IonCard, IonCardHeader, IonCardTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { Machine } from '../../../api/graphql/generated';
import i18n from '../../../i18n';
import { useBeaconRouter } from '../../../route/route.hooks';

interface MachineRealtimeCardProps {
  machine?: Machine;
}

const MachineRealtimeCard = (props: MachineRealtimeCardProps): ReactElement => {
  const { machine } = props;

  const { builder } = useBeaconRouter();

  return (
    <IonCard
      className="machine-card-container"
      routerLink={
        machine
          ? builder.getMachineRealtimeRoute(machine.teamId, machine.id)
          : undefined
      }
    >
      <IonCardHeader>
        <IonCardTitle>
          {i18n.t('common:page_team_machine_realtime')}
        </IonCardTitle>
      </IonCardHeader>
      <p className="card-description">
        {i18n.t('common:machine_realtime_description_for_card')}
      </p>
    </IonCard>
  );
};

export { MachineRealtimeCard };
